import styled from 'styled-components';
import { Swiper } from 'swiper/react';

export const ItemSwiper = styled(Swiper)`
  .swiper-slide {
    flex: 1;
  }
`;
